import React from 'react';
import { Button } from 'reactstrap';

class MyFriendItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
    };
  }

  render() {
    const id = this.props.id;
    if (this.state.disabled === false) {
      return (
        <div
          className="friends-item d-flex flex-row justify-content-between align-items-center"
          onClick={() => this.props.openFriendProfile(true, id)}
        >
          <div className="d-flex">
            {this.props.imgUrl && (
              <img
                src={this.props.imgUrl}
                className="avatar"
                alt={this.props.username ? this.props.username : 'No username'}
                height="118"
                width="118"
              />
            )}
            {!this.props.imgUrl && (
              <div className="avatar-container">
                <i className="icon-profile" />
              </div>
            )}
            {this.props.username ? this.props.username : 'No username'}{' '}
          </div>
          <Button
            color="link"
            className="danger"
            onClick={() => this.props.openRemoveFriendPopUp(id)}
          >
            <i className="icon-remove" />
          </Button>
        </div>
      );
    }
    return null;
  }
}

export default MyFriendItem;
